import React from 'react';

import EventsChartContainer from 'features/Events/containers/EventsChartContainer/EventsChartContainer';
import useStyles from 'features/Frames/components/Frames/FramesTable/components/TableCollapsedContent/TableCollapsedContent.styles';
import TableCollapsedContentDetails from 'features/Frames/components/Frames/FramesTable/components/TableCollapsedContentDetails';
import { Frame } from 'features/Frames/types';

type TableCollapsedContentProps = {
  frame: Frame;
};
const TableCollapsedContent = ({ frame }: TableCollapsedContentProps) => {
  const classes = useStyles();

  const dates = {
    from: 'now-1h',
    to: 'now',
  };

  return (
    <div className={`${classes.collapsible}`}>
      <div>
        <TableCollapsedContentDetails frame={frame} />
      </div>
      <div className={classes.graph}>
        <EventsChartContainer frameId={frame.id} dates={dates} />
      </div>
    </div>
  );
};

export default TableCollapsedContent;
